export default "I bliver holdt fanget af en piratkaptajn. I skal slippe fri, kapre et skib og krydse Det caribiske hav til Piratøen, hvor skatten venter.";